module.exports = __webpack_public_path__ + "static/media/donation-box2.a7c76ea2.jpg";